import { isTimeExceedThreshold } from '@/utils/time'
import {
  chartOptions,
  seriesItem
} from '@/components/Charts/schema/LineChartSchema'
import { markStore } from '@/utils/echart'
import { timetransition } from '@/utils/common'

/**
 * 用于饼图对后端字段的转换
 */
const fieldTable = {
  ex: $t('public.exception'),
  normal: $t('public.normal'),
  run: $t('carrierStatus.running'),
  backup: $t('carrierStatus.spare'),
  defrost: $t('carrierStatus.defrost'),
  retirement: $t('carrierStatus.obsolete'),
  repaired: $t('carrierStatus.require')
}
export default function (data) {
  const result = []
  Object.keys(data).forEach(item => {
    result.push({
      name: fieldTable[item],
      value: data[item]
    })
  })
  return result
}

/**
 * 处理chart图表的异步获取
 * @param request  请求列表
 * @param form  请求参数
 * @param after  成功后操作
 * @param token  请求token
 * @returns {Promise<void>}
 */
export const processToken = async function (request, form, after, token = null) {
  if (token) {
    form.token = token
  }
  // 判断时间是否超过阈值 超过了则使用轮询
  if (isTimeExceedThreshold(form.from, form.to)) {
    form.block = 0
  } else {
    form.block = 1
  }

  const { result } = await request(form)
  if (result.ok) {
    after(result)
  } else {
    setTimeout(() => {
      processToken(request, form, after, result.token)
    }, 1000)
  }

  if (result.token) {
    form.token = result.token
  }
}

/**
 * 将服务器返回的数据转换成Echart数据
 * @param data 数据
 * @param range 区间数据
 * @param probe  temp|hum
 * @returns {{yAxis: {min: function(*): (*|number), max: function(*): *, axisLine: {lineStyle: {color: string, width: number}}, splitLine: {show: boolean}, name: *, type: string}, xAxis: {type: string}, series: [], grid: {left: string, bottom: string, right: string}, dataZoom: [{filterMode: string, realtime: boolean, start: number, end: number, type: string},{dataBackground: {areaStyle: {color: string}}, realtime: boolean, type: string}], toolbox: {feature: {restore: {}, dataZoom: {yAxisIndex: string}}}, tooltip: {formatter: function(*): (string|string), axisPointer: {animation: boolean}, trigger: string}, visualMap: [{pieces: [], show: boolean, type: string, dimension: number, seriesIndex: number}]}}
 */
export const calcSeries = (data, range, probe) => {
  // 监测区间  二位数组
  const markArea = []

  const series = seriesItem(probe)
  // 上一条数据的最大最小值 如果不相等 会创建一个新的区间
  let lastMin = null
  let lastMax = null

  // 折线图中监测区间的最大最小数字
  let valMax = -Number.MAX_VALUE
  let valMin = Number.MAX_VALUE

  // 计算自定义区间
  if (range && range.min !== undefined) {
    markArea.push([
      {
        xAxis: 0,
        yAxis: range.min
      },
      {
        xAxis: data[data.length - 1].time,
        yAxis: range.max
      }
    ])
  }

  data.forEach((item, index) => {
    /**
     * 格式化Echarts数据
     */
    const time = timetransition(item.time)
    series.data.push({
      value: [time, item.val],
      name: time,
      max: item.max,
      min: item.min,
      no: item.no
    })

    const min = item.min
    const max = item.max

    // 计算监测区间最大值和最小值
    if (min < valMin) {
      valMin = min
    }
    if (max > valMax) {
      valMax = max
    }

    if (range && range.min === undefined) {
      if (markArea[markArea.length - 1]) {
        // 有值 往最后一条尾部追加截止时间
        markArea[markArea.length - 1][1].xAxis = time
      }
      if (
        min !== undefined &&
        min !== lastMin &&
        max !== lastMax &&
        data.length !== index + 1
      ) {
        markArea.push([
          {
            xAxis: time,
            yAxis: min
          },
          {
            xAxis: time,
            yAxis: max
          }
        ])
      }
    }

    lastMax = max
    lastMin = min
  })

  /**
   * 设置监测区间
   */
  series.markArea.data = markArea

  const chartOption = chartOptions({
    unit: probe,
    valMin: valMin,
    valMax: valMax
  })
  // 计算store分段
  const pieces = markStore(data)
  if (pieces.length) {
    chartOption.visualMap[0].pieces = pieces
  } else {
    chartOption.visualMap = []
  }
  chartOption.series.push(series)
  return chartOption
}

/**
 * 计算监测区间
 * @param rangeData
 */
export const calcRange = rangeData => {
  rangeData = rangeData.map(item => {
    return [
      {
        xAxis: timetransition(item.minCollectTime),
        yAxis: item.minVal
      },
      {
        xAxis: timetransition(item.maxCollectTime),
        yAxis: item.maxVal
      }
    ]
  })
  return rangeData
}
